// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/cockpit-ergonomics.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/cockpit-ergonomics/cockpit-ergonomics.js';

mount([g0]);
